<template>
    <svg height="38px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           x="0px" y="0px" viewBox="0 0 70 70" style="enable-background:new 0 0 70 70;" xml:space="preserve">
        <g>
          <g>
            <path class="st0-amex" d="M59.4,49.7l-2.6-2.9l-2.7,2.9h-5.3l0,0H37.4V36.2h-5.3l6.6-15.1l6.4,0l2.3,5.2v-5.2h8l1.4,3.9l1.4-3.9l6.1,0
			      v-2.3c0-1.4-1.1-2.5-2.5-2.5H8.2c-1.4,0-2.5,1.1-2.5,2.5v32.5c0,1.4,1.1,2.5,2.5,2.5h53.6c1.4,0,2.5-1.1,2.5-2.5v-1.6L59.4,49.7z"
              />
              <g>
                <polygon class="st0-amex" points="60.1,48.1 64.3,48.1 58.8,42.2 64.3,36.4 60.2,36.4 56.7,40.2 53.3,36.4 49.1,36.4 54.7,42.3
				        49.1,48.1 53.2,48.1 56.7,44.3 60.1,48.1 			"/>
                <polygon class="st0-amex" points="42.4,45.4 42.4,43.6 49,43.6 49,40.9 42.4,40.9 42.4,39.1 49.1,39.1 49.1,36.4 39.2,36.4 39.2,48.1
				        49.1,48.1 49.1,45.4 42.4,45.4 			"/>
                <polygon class="st0-amex" points="61.2,34.7 64.2,34.7 64.2,22.9 59.4,23 56.8,30.3 54.1,23 49.1,23 49.1,34.7 52.3,34.7 52.3,26.5
				        55.3,34.7 58.1,34.7 61.2,26.5 61.2,34.7 			"/>
              <path class="st0-amex" d="M44,23h-4.1l-5.2,11.7h3.5l1-2.3h5.4l1,2.3h3.6L44,23z M40.3,29.7l1.6-3.8l1.6,3.8H40.3z"/>
            </g>
          </g>
          <polygon class="st0-amex" points="61.4,41.9 64.3,45.1 64.3,38.7 61.4,41.9 	"/>
        </g>
      </svg>
</template>

<style type="text/css">
    .st0-amex{fill:#0071CE;}
</style>